import { css } from "@emotion/css";
import { ThinStar } from "@smastrom/react-rating";
import { mobileOnly } from "@v2/styles/breakpoints";
import colors from "@v2/styles/colors";

export const ratingStyles = {
    itemShapes: ThinStar,
    itemStrokeWidth: 2,
    activeFillColor: colors.RED,
    activeStrokeColor: colors.RED,
    inactiveFillColor: 'transparent',
    inactiveStrokeColor: colors.RED
}

export const styles = css({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontSize: 16,
    textAlign: 'center',
    lineHeight: 1,

    [mobileOnly]: {
        fontSize: 14,
    },

    '.rating': {
        maxWidth: 120,
        marginLeft: 6,
    }
});
